import Footer from "../Footer";
import Header from "../Header";
import React, { FC } from "react";
import SailInfoFeedback from "./SailInfoFeedback";
import SailInfoSailHeader from "./SailInfoSailHeader";
import SailInfoSailMaterial from "./SailInfoSailMaterial";
import SailInfoSalesPerson from "./SailInfoSalesPerson";
import SailInfoSizing from "./SailInfoSizing";
import SailInfoTimeline from "./SailInfoTimeline";
import SailServiceOrderItems from "./SailInfoServiceOrderItems";
import Stack from "@mui/material/Stack";
import { useParams } from "react-router";
import { Certificates } from "../Downloads/Certificates";

interface SailInfoProps {}

const SailInfo: FC<SailInfoProps> = ({}) => {
    const { guid } = useParams<{ guid?: string }>();

    return (
        <div
            style={{
                padding: 0,
                display: "flex",
                flexDirection: "column",
                minHeight: "100vh",
                justifyContent: "space-between",
            }}
        >
            <Stack
                spacing={3}
                sx={{
                    margin: 2,
                    alignItems: "center",
                }}
            >
                <Header Title="Sail Information" />
                <SailInfoSailHeader guid={guid ?? ""} />
                <SailInfoSalesPerson guid={guid ?? ""} />
                <SailInfoSizing guid={guid ?? ""} />
                <SailInfoSailMaterial guid={guid ?? ""} />
                <SailInfoFeedback guid={guid ?? ""} />
                <SailServiceOrderItems guid={guid ?? ""} />
                <SailInfoTimeline guid={guid ?? ""} />
                <Certificates guid={guid ?? ""} />
            </Stack>
            <Footer />
        </div>
    );
};

export default SailInfo;
